import React, { useState, useEffect } from 'react';

import { Box, LinearProgress } from '@mui/joy';
import { Text } from '../Typography';
import { Icon } from '../../assets';
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { DataGridPro, GridFooterContainer } from '@mui/x-data-grid-pro'
import { RouterAnchor } from 'src/mtska-frontend-app-component/components/RouterAnchor';
import { useDrawer } from '../Drawer';
import { Button } from '../Button';
import { useDashboardPrintRender } from 'src/mtska-frontend-modules/modules/_shared/dashboardConfigured/DashboardPrintRenderContext';

const Table = ({ title, dataProviderName, icon, filters, columns, drawerRouteBase, showAllRoute }) => {
    const { items, loadAll, loading } = useDataProvider(dataProviderName);
    const [drawable, setDrawable] = useState(false);
    const { activate } = useDrawer();
    const printMode = useDashboardPrintRender();

    const { t } = useTranslation();

    useEffect(() => {
        if (!filters || !dataProviderName || loading) return;
        loadAll(filters);
    }, [filters]);

    useEffect(() => {
        if (items && Array.isArray(items)) {
            setDrawable(true)
        }
    }, [items])

    const handleRowClick = (item) => {
        if (item.status == 'running' && (item.id || item._id)) {
            activate(drawerRouteBase + '/detail', { id: item.id ?? item._id });
        }
    }


    function CustomFooter() {
        if (!showAllRoute) return null;

        return (
            <GridFooterContainer>
                <RouterAnchor
                    href={showAllRoute}
                    underline="none"
                    className="buttonized MuiButton-variantSolid input-button tiny"
                    style={{ verticalAlign: 'middle', marginLeft: '10px' }}
                    variant={'text'}
                >
                    {t('Vedi tutti')}
                </RouterAnchor>
            </GridFooterContainer>
        );
    }


    return (
        <Box className={`mtska-chart mtska-chart-table${printMode ? ' mtska-chart-table--print' : ''}`}>
            <Icon icon={icon} family="fal"></Icon>
            <Text level="title-sm" className="title">{title}</Text>
            {
                !drawable || loading ? <LinearProgress /> :
                    <DataGridPro
                        rows={items}
                        columns={columns}
                        onRowDoubleClick={(params) => handleRowClick(params.row)}
                        getRowId={(row) => row._id} // Usare _id come identificatore univoco per le righe
                        disableColumnSelector
                        disableRowSelectionOnClick
                        pageSize={10}
                        rowHeight={30}
                        rowsPerPageOptions={[10, 25, 50]}
                        autoHeight={printMode}
                        hideFooter={printMode}
                        className="mtska-chart-table-data"
                        slots={printMode ? undefined : { footer: CustomFooter }}
                        localeText={{
                            noRowsLabel: 'Nessun risultato trovato',
                        }}
                        sx={printMode ? { minHeight: 'unset', height: 'auto' } : { minHeight: 410 }}
                    />
            }
        </Box>
    );
}

export default Table;